(function () {
  'use strict';

  // Slow down playback without changing the video file.
  // 1.0 = normal speed, 0.5 = half speed, 0.75 = 75% speed.
  var PLAYBACK_RATE = 1;

  // Initialize one instance per container (desktop + mobile independently)
  function initVideoCallouts(sectionEl) {
    initContainer(
      sectionEl.querySelector('.sv-desktop-video'),
      sectionEl.querySelector('.scroll-video__sticky-container')
    );
    initContainer(
      sectionEl.querySelector('.sv-mobile-video'),
      sectionEl.querySelector('.scroll-video__mobile-container')
    );
  }

  function initContainer(video, container) {
    if (!video || !container) return;

    var callouts = Array.from(container.querySelectorAll('.scroll-video__callout[data-timestamp]'));

    var sortedSteps = callouts
      .map(function (el) {
        return {
          pct: Math.max(0, Math.min(100, parseFloat(el.dataset.timestamp) || 0)),
          el: el
        };
      })
      .sort(function (a, b) { return a.pct - b.pct; });

    var segments = Array.from(container.querySelectorAll('.scroll-video__progress-segment'));

    var activeIndex = -1;
    var rafId       = null;

    function pctToTime(pct) {
      var dur = video.duration;
      return (!dur || isNaN(dur)) ? 0 : (pct / 100) * dur;
    }

    // ── Update active callout — sequential fade (out then in) ──
    var fadeOutTimer = null;
    function updateCallout(t, dur) {
      var newActive = 0;
      for (var i = 0; i < sortedSteps.length; i++) {
        if (t >= pctToTime(sortedSteps[i].pct) - 0.05) newActive = i;
      }
      if (newActive !== activeIndex) {
        var prevIndex = activeIndex;
        activeIndex = newActive;

        // Immediately fade out the previous callout
        if (prevIndex >= 0 && sortedSteps[prevIndex]) {
          sortedSteps[prevIndex].el.classList.remove('is-active');
        }

        // Fade in the new callout after the fade-out completes (350ms)
        if (fadeOutTimer) clearTimeout(fadeOutTimer);
        var targetStep = sortedSteps[newActive];
        fadeOutTimer = setTimeout(function () {
          if (targetStep) targetStep.el.classList.add('is-active');
        }, 350);
      }
    }

    // ── Update segmented progress bar at 60fps ────────────────
    // One segment per slide. Each segment fills between its
    // timestamp and the next slide's timestamp. The last segment
    // fills from its timestamp to video.duration.
    var lastTime = 0;
    function updateProgress(t, dur) {
      // Detect loop: if time jumped backward significantly, reset all segments
      if (t < lastTime - 0.5) {
        segments.forEach(function (seg) {
          seg.classList.remove('is-complete');
          var bar = seg.querySelector('.scroll-video__progress-fill');
          if (bar) bar.style.height = '0%';
        });
      }
      lastTime = t;

      segments.forEach(function (seg, i) {
        var step     = sortedSteps[i];
        var nextStep = sortedSteps[i + 1];
        if (!step) return;

        var segStart = pctToTime(step.pct);
        var segEnd   = nextStep ? pctToTime(nextStep.pct) : dur;

        var fill;
        if (t >= segEnd) {
          fill = 100;
          seg.classList.add('is-complete');
        } else if (t < segStart) {
          fill = 0;
          seg.classList.remove('is-complete');
        } else {
          fill = segEnd > segStart
            ? Math.min(100, Math.max(0, ((t - segStart) / (segEnd - segStart)) * 100))
            : 100;
          seg.classList.remove('is-complete');
        }

        var bar = seg.querySelector('.scroll-video__progress-fill');
        if (bar) bar.style.height = fill + '%';
      });
    }

    // ── rAF loop ──────────────────────────────────────────────
    function startRaf() {
      if (rafId) return;
      function tick() {
        rafId = requestAnimationFrame(tick);
        var t   = video.currentTime;
        var dur = video.duration;
        if (!dur || isNaN(dur)) return;
        updateCallout(t, dur);
        updateProgress(t, dur);
      }
      tick();
    }

    function stopRaf() {
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    }

    // ── Activate first callout immediately ────────────────────
    if (sortedSteps.length) {
      sortedSteps[0].el.classList.add('is-active');
      activeIndex = 0;
    }

    // ── IntersectionObserver: play/pause on visibility ────────────
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.playbackRate = PLAYBACK_RATE; video.play().catch(function () {});
            startRaf();
          } else {
            video.pause();
            stopRaf();
          }
        });
      }, { threshold: 0.1 });
      observer.observe(container);
    } else {
      video.playbackRate = PLAYBACK_RATE; video.play().catch(function () {});
      startRaf();
    }

    // ── Shopify editor reload ────────────────────────────────────────
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.contains(container)) {
        activeIndex = -1;
        if (sortedSteps.length) {
          sortedSteps[0].el.classList.add('is-active');
          activeIndex = 0;
        }
        video.currentTime = 0;
        video.playbackRate = PLAYBACK_RATE; video.play().catch(function () {});
        startRaf();
      }
    });

    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target.contains(container)) stopRaf();
    });
  }

  function init() {
    document.querySelectorAll('.scroll-video-section').forEach(initVideoCallouts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.scroll-video-section');
    if (el) initVideoCallouts(el);
  });

})();
